/* 北海道の森を描く・スクロールで木と動物を出す・文字盤の針をいまの時刻に合わせる（hidane.co.jp v2 から移植） */
(function(){
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) root.classList.add('hf-js');

  var NS = 'http://www.w3.org/2000/svg';
  var seed = 1;
  // 描く場所ごとに乱数を固定して、毎回同じ形になるようにする
  function setSeed(name){ seed = 20230217; for (var i = 0; i < name.length; i++) seed = (seed * 31 + name.charCodeAt(i)) % 4294967296; }
  function rnd(){ seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; }
  function el(tag, attrs, parent){ var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); parent.appendChild(e); return e; }
  function pts(a){ return a.map(function(p){ return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }
  var PENCIL = 'url(#hf-pencil)';

  // 遠くの山（雪をかぶった稜線）
  function ridge(baseY, amp, color, snow, into, W, H){
    var k = W < 1000 ? .5 : 1;
    var p = [[0, H]], x = 0, peaks = [];
    while (x <= W){ peaks.push([x, baseY - amp * (0.35 + rnd() * 0.65)]); x += (120 + rnd() * 160) * k; }
    peaks.forEach(function(q){ p.push(q); }); p.push([W, baseY - amp * .4], [W, H]);
    el('polygon', {points: pts(p), fill: color, filter: PENCIL}, into);
    if (snow) peaks.forEach(function(q){
      var w = (26 + rnd() * 22) * (k < 1 ? .7 : 1);
      el('polygon', {points: pts([[q[0] - w, q[1] + w * .55], [q[0], q[1]], [q[0] + w, q[1] + w * .55], [q[0] + w * .4, q[1] + w * .4], [q[0], q[1] + w * .62], [q[0] - w * .4, q[1] + w * .38]]), fill: '#F7F9FA', opacity: .95, filter: PENCIL}, into);
    });
  }
  // トドマツ（段々の針葉樹）
  function fir(x, base, h, color, delay, into){
    var g = el('g', {'class': 'tree', style: '--d:' + delay.toFixed(2) + 's', filter: PENCIL}, into);
    el('rect', {x: x - h * .025, y: base - h * .12, width: h * .05, height: h * .14, fill: '#6B5847'}, g);
    var tiers = 5 + Math.floor(rnd() * 3), top = base - h, left = [], right = [];
    for (var i = 1; i <= tiers; i++){
      var ty = top + (h * .9) * (i / tiers), w = h * (.08 + .27 * (i / tiers)) * (0.9 + rnd() * .2);
      right.push([x + w, ty], [x + w * .42, ty - h * .05]);
      left.unshift([x - w * .42, ty - h * .05], [x - w, ty]);
    }
    right.pop(); left.shift();
    el('polygon', {points: pts([[x, top]].concat(right, [[x, base - h * .08]], left)), fill: color}, g);
  }
  // シラカバ（白い幹と黄葉）
  function birch(x, base, h, delay, into){
    var g = el('g', {'class': 'tree', style: '--d:' + delay.toFixed(2) + 's', filter: PENCIL}, into);
    var lean = (rnd() - .5) * 14, w = h * .045;
    el('polygon', {points: pts([[x - w / 2, base], [x + w / 2, base], [x + lean + w * .25, base - h * .78], [x + lean - w * .25, base - h * .78]]), fill: '#F6F5EF', stroke: '#B9B4A8', 'stroke-width': 1.4}, g);
    for (var i = 0; i < 7; i++){
      var yy = base - h * (.08 + rnd() * .62), t = (base - yy) / (h * .78);
      el('rect', {x: x + lean * t - w * .45, y: yy, width: w * (.35 + rnd() * .45), height: 2 + rnd() * 2.5, fill: '#3E3A36', rx: 1}, g);
    }
    var cx = x + lean, cy = base - h * .8, leaf = ['#D9C46A', '#E3CF7A', '#C9B65A', '#BFC27A'];
    for (var j = 0; j < 9; j++) el('ellipse', {cx: cx + (rnd() - .5) * h * .42, cy: cy + (rnd() - .4) * h * .3, rx: h * (.07 + rnd() * .07), ry: h * (.06 + rnd() * .05), fill: leaf[j % 4], opacity: .92}, g);
  }
  function stump(x, y, w, h, into){
    var st = el('g', {filter: PENCIL}, into);
    el('rect', {x: x, y: y, width: w, height: h, rx: w * .1, fill: '#7A6450'}, st);
    el('ellipse', {cx: x + w / 2, cy: y + 1, rx: w / 2, ry: w * .13, fill: '#C9AE8A'}, st);
  }
  function rowOf(list, base, into){
    list.forEach(function(t, i){ var d = .05 * i; if (t[1] === 'f') fir(t[0], base, t[2], t[3], d, into); else birch(t[0], base, t[2], d, into); });
  }

  var DRAW = {
    // PCのヒーロー：遠景の森 → 中景 → 雪原 → 手前の大木
    hero: function(s){
      ridge(330, 130, '#C3D2DA', true, s, 1600, 600);
      ridge(380, 90, '#AFC3BE', false, s, 1600, 600);
      for (var i = 0; i < 22; i++) fir(rnd() * 1600, 452 + rnd() * 18, 70 + rnd() * 50, i % 3 ? '#8FA79B' : '#9DB2A6', .1 + rnd() * .4, s);
      [470, 1000, 1390].forEach(function(x, k){ birch(x + (rnd() - .5) * 40, 500, 210 + rnd() * 70, .3 + k * .07, s); });
      for (var m = 0; m < 8; m++){
        var mx = 80 + m * 200 + (rnd() - .5) * 50;
        if (Math.abs(mx - 800) < 140) continue;
        fir(mx, 498 + rnd() * 10, 150 + rnd() * 110, m % 2 ? '#5F7D6B' : '#557364', .25 + rnd() * .35, s);
      }
      el('path', {d: 'M0 495 C 220 470 420 512 640 492 C 860 472 1080 514 1300 490 C 1440 476 1530 486 1600 482 L1600 600 L0 600 Z', fill: 'url(#hf-snowg)', filter: PENCIL}, s);
      el('path', {d: 'M0 540 C 300 528 560 556 860 540 C 1140 526 1380 552 1600 536', fill: 'none', stroke: '#E1E6E2', 'stroke-width': 3, 'stroke-linecap': 'round'}, s);
      stump(1180, 465, 62, 42, s);
      fir(40, 600, 520, '#2F4B3E', 0, s);
      fir(1500, 600, 470, '#2F4B3E', .05, s); fir(1585, 600, 560, '#3A5A4A', .15, s);
      for (var f = 0; f < 9; f++) el('ellipse', {cx: 980 + f * 26 + (f % 2) * 6, cy: 560 - f * 3 + (f % 2) * 8, rx: 4, ry: 2.6, fill: '#D3D9D4'}, s);
    },
    // スマホのヒーロー：縦長の画面に収まるよう組み直した森
    'hero-m': function(s){
      ridge(205, 60, '#C3D2DA', true, s, 400, 340);
      ridge(232, 38, '#AFC3BE', false, s, 400, 340);
      for (var a = 0; a < 9; a++) fir(rnd() * 400, 254 + rnd() * 8, 28 + rnd() * 22, a % 3 ? '#8FA79B' : '#9DB2A6', .1 + rnd() * .3, s);
      [70, 300].forEach(function(x, k){ birch(x, 274, 100 + rnd() * 26, .25 + k * .08, s); });
      [24, 180, 372].forEach(function(x, k){ fir(x, 274, 60 + rnd() * 38, k % 2 ? '#5F7D6B' : '#557364', .2 + k * .06, s); });
      el('path', {d: 'M0 274 C 100 268 300 280 400 271 L400 340 L0 340 Z', fill: 'url(#hf-snowg)', filter: PENCIL}, s);
      stump(330, 254, 34, 22, s);
      for (var f = 0; f < 6; f++) el('ellipse', {cx: 250 + f * 14 + (f % 2) * 3, cy: 312 - f * 2 + (f % 2) * 5, rx: 2.6, ry: 1.7, fill: '#D3D9D4'}, s);
    },
    // フクロウの止まり枝（右の画面外から伸びるトドマツの枝）
    branch: function(b){
      var g = el('g', {filter: PENCIL}, b);
      el('path', {d: 'M470 276 C 455 252 440 238 418 226', stroke: '#6B5847', 'stroke-width': 5, 'stroke-linecap': 'round', fill: 'none'}, g);
      el('path', {d: 'M560 272 C 548 300 540 318 520 334', stroke: '#6B5847', 'stroke-width': 6, 'stroke-linecap': 'round', fill: 'none'}, g);
      el('path', {d: 'M190 293 C 172 306 160 320 140 330', stroke: '#6B5847', 'stroke-width': 3.5, 'stroke-linecap': 'round', fill: 'none'}, g);
      [[418,226,26],[520,334,30],[600,262,46],[575,300,38],[140,330,20],[86,301,18],[505,262,24]].forEach(function(c){
        for (var i = 0; i < 40; i++){
          var a = rnd() * Math.PI * 2, r = c[2] * (.45 + rnd() * .55);
          el('line', {x1: c[0], y1: c[1], x2: (c[0] + Math.cos(a) * r).toFixed(1), y2: (c[1] + Math.sin(a) * r * .8).toFixed(1), stroke: i % 3 ? '#3A5A4A' : '#5F7D6B', 'stroke-width': 2.4, 'stroke-linecap': 'round'}, g);
        }
      });
      el('path', {d: 'M640 262 C 470 274 330 284 80 300 L 82 306 C 330 298 470 292 640 292 Z', fill: '#6B5847'}, g);
      el('path', {d: 'M640 286 C 470 288 330 294 90 304', stroke: '#4E4034', 'stroke-width': 2, fill: 'none', opacity: .6}, g);
      el('path', {d: 'M560 266 C 520 262 480 266 440 268 C 420 266 400 270 360 274 C 330 272 300 278 250 282 C 220 281 190 286 150 290 L 150 293 C 300 285 450 275 560 270 Z', fill: '#FFFFFF'}, g);
    },
    // 本文の左右の余白に生える木立
    'grove-a': function(g){ fir(60, 258, 200, '#3A5A4A', 0, g); birch(125, 258, 230, .14, g); fir(225, 258, 120, '#5F7D6B', .28, g); },
    'grove-b': function(g){ birch(150, 258, 210, 0, g); fir(215, 258, 230, '#2F4B3E', .14, g); },
    'grove-c': function(g){ fir(45, 258, 160, '#5F7D6B', 0, g); fir(105, 258, 215, '#3A5A4A', .12, g); birch(230, 258, 170, .26, g); },
    'grove-d': function(g){ fir(130, 258, 190, '#3A5A4A', 0, g); fir(210, 258, 130, '#5F7D6B', .16, g); },
    // 雪の丘の帯：地面は横いっぱい、木立は左右の端に寄せて描く（狭い画面でも切れない）
    'strip-ground': function(s){
      el('path', {d: 'M0 170 C 260 150 520 166 800 158 C 1080 150 1340 168 1600 156 L1600 200 L0 200 Z', fill: '#FFFFFF', filter: PENCIL}, s);
    },
    'strip-l': function(s){ rowOf([[40,'f',120,'#3A5A4A'],[110,'b',140],[185,'f',85,'#5F7D6B']], 196, s); },
    'strip-r': function(s){ rowOf([[75,'f',95,'#5F7D6B'],[150,'b',130],[220,'f',140,'#2F4B3E']], 196, s); },
    // 商品・一覧ページの、雪の丘の帯（旧）
    strip: function(s){
      el('path', {d: 'M0 170 C 260 150 520 166 800 158 C 1080 150 1340 168 1600 156 L1600 200 L0 200 Z', fill: '#FFFFFF', filter: PENCIL}, s);
      rowOf([[50,'f',120,'#3A5A4A'],[120,'b',140],[190,'f',85,'#5F7D6B'],[1380,'f',95,'#5F7D6B'],[1450,'b',130],[1540,'f',140,'#2F4B3E']], 166, s);
    },
    // セクションの間の、小さな木が並ぶライン（左から順に生える）
    treeline: function(s){
      el('path', {d: 'M0 61 H1600', stroke: '#DDE3DE', 'stroke-width': 2, 'stroke-linecap': 'round', fill: 'none'}, s);
      var greens = ['#5F7D6B', '#3A5A4A', '#557364', '#8FA79B'], x = 6, i = 0;
      while (x < 1600){
        var h = 20 + rnd() * 34;
        if (rnd() < .16) birch(x, 60, h * 1.15, i * .025, s); else fir(x, 60, h, greens[Math.floor(rnd() * 4)], i * .025, s);
        x += 14 + rnd() * 30; i++;
      }
    },
    // フッターの森（PC）：奥の淡い木立と、手前の木立を間をあけて横いっぱいに
    foot: function(s){
      forest(s, 1600, 214, 26, 62, [50, 40], 86, 70, [90, 60]);
    },
    // フッターの森（スマホ）
    'foot-m': function(s){
      forest(s, 400, 220, 9, 46, [40, 28], 50, 30, [76, 44]);
    }
  };
  // 奥（淡い色・小さめ）と手前（濃い色・大きめ）の2列で、横いっぱいに木を並べる。手前は3本に1本がシラカバ
  function forest(s, W, base, nBack, stepBack, hBack, stepFront, jitter, hFront){
    for (var i = 0; i < nBack; i++) fir(i * stepBack + rnd() * stepBack * .6, base, hBack[0] + rnd() * hBack[1], i % 3 ? '#8FA79B' : '#9DB2A6', rnd() * .4, s);
    var greens = ['#5F7D6B', '#3A5A4A', '#557364', '#2F4B3E'], x = rnd() * 12, j = 0;
    while (x < W){
      var h = hFront[0] + rnd() * hFront[1];
      if (j % 3 === 1) birch(x, base, h * 1.1, .2 + j * .03, s); else fir(x, base, h, greens[j % 4], .2 + j * .03, s);
      x += stepFront + rnd() * jitter; j++;
    }
  }
  var GROVE_GROUND = 'M0 262 C 40 246 90 250 130 244 C 170 238 220 248 260 252 L260 262 Z';

  function drawAll(scope){
    (scope || document).querySelectorAll('svg[data-hf-draw]').forEach(function(s){
      if (s.dataset.hfDone) return;
      var kind = s.getAttribute('data-hf-draw');
      if (!DRAW[kind]) return;
      setSeed(kind + (s.getAttribute('data-hf-seed') || ''));
      if (kind.indexOf('grove') === 0) el('path', {d: GROVE_GROUND, fill: '#FFFFFF', filter: PENCIL}, s);
      DRAW[kind](s);
      s.dataset.hfDone = '1';
    });
  }

  /* ---- スクロール時の表示（入るたびに出て、出たら戻る） ---- */
  var io = root.classList.contains('hf-js') ? new IntersectionObserver(function(es){
    es.forEach(function(e){ e.target.classList.toggle('in', e.isIntersecting); });
  }, {threshold: .12, rootMargin: '0px 0px -30px 0px'}) : null;
  function watch(scope){
    if (!io) return;
    (scope || document).querySelectorAll('.hf-reveal, [data-hf-pop], .hf-critter').forEach(function(n){ io.observe(n); });
  }

  /* ---- 文字盤の針を、いまの日本時間に合わせる ---- */
  function tick(){
    var d = new Date(Date.now() + (new Date().getTimezoneOffset() + 540) * 60000);
    var h = d.getHours(), m = d.getMinutes(), s = d.getSeconds();
    root.style.setProperty('--hf-rh', ((h % 12) * 30 + m * .5) + 'deg');
    root.style.setProperty('--hf-rm', (m * 6 + s * .1) + 'deg');
    root.style.setProperty('--hf-rs', (s * 6) + 'deg');
    document.querySelectorAll('[data-hf-now]').forEach(function(n){ n.textContent = h + ':' + (m < 10 ? '0' : '') + m; });
  }

  /* ---- ヘッダーの高さ（ヒーローの空をヘッダーの裏まで伸ばす） ---- */
  function headH(){
    var h = document.querySelector('.section-header');
    if (h) root.style.setProperty('--hf-head-h', h.offsetHeight + 'px');
  }

  function init(scope){ drawAll(scope); watch(scope); }
  init(); tick(); headH();
  setInterval(tick, 1000);
  window.addEventListener('resize', headH, {passive: true});
  // テーマエディタでセクションを差し替えたときも描き直す
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
